__turbopack_context__.v({
  "btn": "style-module-scss-module__K49bcW__btn",
  "content": "style-module-scss-module__K49bcW__content",
  "follow": "style-module-scss-module__K49bcW__follow",
  "img": "style-module-scss-module__K49bcW__img",
  "subtitle": "style-module-scss-module__K49bcW__subtitle",
  "title": "style-module-scss-module__K49bcW__title",
  "wrapper": "style-module-scss-module__K49bcW__wrapper",
});
